import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import PaversConcreteStoneWork from "./pages/PaversConcreteStoneWork.tsx";
import FencesDeckConstruction from "./pages/FencesDeckConstruction.tsx";
import LandscapeInstallation from "./pages/LandscapeInstallation.tsx";
import StructuralGroundWork from "./pages/StructuralGroundWork.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/pavers-concrete-stonework" element={<PaversConcreteStoneWork />} />
        <Route path="/fences-deck-construction" element={<FencesDeckConstruction />} />
        <Route path="/landscape-installation" element={<LandscapeInstallation />} />
        <Route path="/structural-ground-work" element={<StructuralGroundWork />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
